import api from './api';
import { executeRecaptcha } from './recaptcha';

// signup / login / forgot-password auto-attach a v3 reCAPTCHA token;
// backend enforceRecaptcha picks it up. Returns null when not configured.
const withRecaptcha = async (action, data) => {
  const recaptcha_token = await executeRecaptcha(action);
  return { ...data, recaptcha_token };
};

const authService = {
  signup:         async (data)        => api.post('/auth/signup',          await withRecaptcha('register',        data)),
  login:          async (credentials) => api.post('/auth/login',           await withRecaptcha('login',           credentials)),
  verifyOtp:      (data)              => api.post('/auth/verify-otp', data),
  resendOtp:      (data)              => api.post('/auth/resend-otp', data),
  refresh:        ()                  => api.post('/auth/refresh'),
  logout:         ()                  => api.post('/auth/logout'),
  logoutAll:      ()                  => api.post('/auth/logout-all'),
  getMe:          ()                  => api.get('/auth/me'),
  changePassword: (data)              => api.put('/auth/change-password', data),
  forgotPassword: async (data)        => api.post('/auth/forgot-password', await withRecaptcha('forgot_password', data)),
  resetPassword:  (data)              => api.post('/auth/reset-password', data),
};

export default authService;
